/* eslint-disable react/jsx-props-no-spreading */
import React, { CSSProperties } from 'react';
import { ConfigProvider, Modal as AntModal, ModalProps } from 'antd';
import classNames from 'classnames';
import { THEME_CONFIG } from 'Constants/theme';

import styles from './styles.less';

interface Props extends ModalProps {
  scrollBody?: boolean;
  bodyStyle?: CSSProperties;
}

const scrollBodyStyle: React.CSSProperties = {
  maxHeight: 'calc(100vh - 290px)',
  overflow: 'auto',
};

function Modal({ scrollBody, bodyStyle, className, ...rest }: Props) {
  return (
    <ConfigProvider
      theme={{
        ...THEME_CONFIG,
        components: {
          ...THEME_CONFIG.components,
          Select: {
            zIndexPopup: 1005,
          },
          Popover: {
            zIndexPopup: 1001, // more than popup (1000) and less than select
          },
        },
      }}>
      <AntModal
        destroyOnClose
        centered
        maskClosable={false}
        transitionName=""
        className={classNames(styles.container, className)}
        styles={{ body: scrollBody ? { ...scrollBodyStyle, ...bodyStyle } : bodyStyle }}
        footer={false}
        {...rest}
      />
    </ConfigProvider>
  );
}

export default Modal;
